import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { useLocale } from 'hooks/useLocale';
import { StaleTime } from 'queries/types';

import { lineupSelectionQuery } from './queries';

/** What an event page needs to send a reader into the lineup. */
export const useLineupSelection = () => {
  const { query } = useRouter();
  const { locale } = useLocale();

  const reactQuery = useQuery({
    ...lineupSelectionQuery({ locale, slug: `${query.slug}` }),
    staleTime: StaleTime.FOREVER,
  });

  const lineup = reactQuery.data?.pageEvent?.lineups[0];

  return {
    programs: reactQuery.data?.pageEvent?.programs,
    hasLineup: !!lineup,
    entries: lineup?.entries.filter((entry) => !entry.hidden),
    timezone: reactQuery.data?.pageEvent?.timezone,
    isLoading: reactQuery.isLoading,
  };
};
